//Material ui icons
import {
  Restaurant,
  People,
  RateReview,
  AccountBalance,
  RepeatOne,
  Folder,
  VpnKey,
  FolderOpenOutlined,
} from "@material-ui/icons";
import SettingsOverscanIcon from '@material-ui/icons/SettingsOverscan';
export const listItems = [
  {
    pageURL: "/",
    text: "Restaurants",
    Icon: Restaurant,
  },
  {
    pageURL: "/customers",
    text: "Customers",
    Icon: People,
  },
  {
    pageURL: "/new-requests",
    text: "New Requests",
    Icon: RateReview,
  },
  {
    pageURL: "/transaction",
    text: "Transactions",
    Icon: AccountBalance,
  },
  {
    pageURL: "/resend-pass",
    text: "Resend Password",
    Icon: RepeatOne,
  },
  {
    pageURL: "/version",
    text: "Version Control",
    Icon: SettingsOverscanIcon,
  },
  {
    pageURL: "/license-apikeys",
    text: "License Apikeys",
    Icon: VpnKey,
  },
  {
    pageURL: "/pos-data",
    text: "POS Data",
    Icon: Folder,
  },
  {
    pageURL: "/gateway",
    text: "Gateway List",
    Icon: AccountBalance,
  },
  {
    pageURL: "/sms-report",
    text: "SMS Report",
    Icon: FolderOpenOutlined,
  },
];
